import React, { useState } from "react";
import { Plus, SquarePen, CirclePlus, X } from "lucide-react";
import ShiftManagement from "./ShiftManagement";
import LeaveTypeManagement from "./LeaveTypeManagement";
import { MissPunch } from "./MissPunch";
import { OutDoorEntries } from "./OutDoorEntries";
import { active } from "sortablejs";
import GraceWeekoffSettings from "./GraceWeekoffSettings";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("grace");
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    setIsOn((prev) => !prev);
  };

  const [times, setTimes] = useState([""]);

  const handleAddTime = () => {
    setTimes([...times, ""]);
  };

  const handleTimeChange = (index, value) => {
    const updatedTimes = [...times];
    updatedTimes[index] = value;
    setTimes(updatedTimes);
  };

  const handleDeleteTime = (index) => {
    const updatedTimes = times.filter((_, i) => i !== index);
    setTimes(updatedTimes);
  };

  const handleSaveTime = () => {
    console.log("Saved Times:", times);
    alert("Auto-Audit times saved successfully!");
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="hrms-settings-cont">
            <div className="hrms-settings-inner-cont">
              <div class="d-flex flex-column">
                <h5 class="fs-4 fw-semibold m-0">Application Settings</h5>
                <span class="text-muted fs-6">
                  Manage system-wide configurations for attendance and audits
                  for property
                </span>
              </div>

              <div className="hrms-settings-tabs-cont mt-4">
                <div className="hrms-settings-tabs flex-lg-row flex-column">
                  <button
                    className={`hrms-settings-tab-btn ${
                      activeTab === "grace" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("grace")}
                  >
                    Grace Time & Audit
                  </button>

                  <button
                    className={`hrms-settings-tab-btn ${
                      activeTab === "shift" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("shift")}
                  >
                    Shift Management
                  </button>

                  <button
                    className={`hrms-settings-tab-btn ${
                      activeTab === "leaveType" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("leaveType")}
                  >
                    LeaveType Management
                  </button>
                  <button
                    className={`hrms-settings-tab-btn ${
                      activeTab === "missPunch" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("missPunch")}
                  >
                    Miss Punches
                  </button>
                  <button
                    className={`hrms-settings-tab-btn ${
                      activeTab === "outdoor" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("outdoor")}
                  >
                    Outdoor Entries
                  </button>
                </div>

                <div className="hrms-settings-tab-content">
                  {activeTab === "grace" && <GraceWeekoffSettings />}
                  {activeTab === "shift" && <ShiftManagement />}
                  {activeTab == "leaveType" && <LeaveTypeManagement />}
                  {activeTab == "missPunch" && <MissPunch />}
                  {activeTab == "outdoor" && <OutDoorEntries />}

                  {/* {activeTab === "notifications" && (
                    <div>
                      <div className="py-4 text-center text-muted">
                        Notification settings will be available here in a future
                        update.
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
